/* The Greenhouse: plants grow frame by frame when you arrive. The watering can follows your cursor along the shelf;
   click and it tips, drops fall, the plant underneath bounces up and shows its tag. On touch, tap a plant. */
(function () {
  'use strict';
  var WH = window.WH;
  if (!WH) return;
  WH.register('greenhouse', function (sec) {
    var stage = sec.querySelector('[data-stage]'), can = sec.querySelector('[data-can]'), canImg = sec.querySelector('[data-can-img]');
    var plants = Array.prototype.slice.call(sec.querySelectorAll('[data-plant]'));
    var bodies = plants.map(function (p) { return p.querySelector('[data-plant-body]'); });
    var tx = 0.5, cx = 0.5, pouring = false, visible = false;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(sec);
    else visible = true;

    /* grow on arrival */
    if (WH.anim && 'IntersectionObserver' in window) {
      gsap.set(bodies, { scale: 0.35, y: 30 });
      var gio = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        gio.disconnect();
        bodies.forEach(function (b, i) {
          gsap.timeline({ delay: i * 0.14 })
            .to(b, { scale: 0.7, y: 0, duration: 0.25, ease: WH.sm('power1.out', 0.25) })
            .to(b, { scale: 1.12, scaleY: 1.2, duration: 0.25, ease: WH.sm('power2.out', 0.25) })
            .to(b, { scale: 1, scaleY: 1, duration: 0.42, ease: WH.sm('elastic.out(1.2,.4)', 0.42) });
        });
      }, { rootMargin: '0px 0px -28% 0px' });
      gio.observe(stage);
    }

    function stageX(clientX) { var r = stage.getBoundingClientRect(); return WH.clamp((clientX - r.left) / r.width, 0.1, 0.9); }
    stage.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') tx = stageX(e.clientX); });
    if (!WH.reduce) {
      /* the can follows the pointer every display frame; its little bob stays a 12 fps pose */
      var shown = -1;
      WH.onTick(function (dt) {
        if (!visible) return;
        cx += (tx - cx) * WH.ease(0.4, dt);
        if (Math.abs(cx - shown) < 0.0005) return;
        shown = cx;
        can.style.left = (cx * 100).toFixed(2) + '%';
      });
      WH.onFrame(function (f) {
        if (!visible || pouring) return;
        canImg.style.transform = 'translateY(' + (f % 4 < 2 ? -3 : 0) + 'px)';
      });
    } else can.style.left = '50%';

    function nearest(nx) {
      var r = stage.getBoundingClientRect(), best = 0, bd = 1e9;
      bodies.forEach(function (b, i) { var br = b.getBoundingClientRect(), d = Math.abs((br.left + br.width / 2 - r.left) / r.width - nx); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function pour(i) {
      if (pouring) return;
      pouring = true;
      var r = stage.getBoundingClientRect(), br = bodies[i].getBoundingClientRect();
      tx = cx = WH.clamp((br.left + br.width * 0.85 - r.left) / r.width, 0.1, 0.92);
      can.style.left = (cx * 100).toFixed(2) + '%';
      var done = function () {
        pouring = false;
        plants[i].classList.add('is-watered');
        clearTimeout(plants[i].__t);
        plants[i].__t = setTimeout(function () { plants[i].classList.remove('is-watered'); }, 3600);
      };
      if (!WH.anim) { done(); return; }
      var cr = canImg.getBoundingClientRect();
      var sx = cr.left - r.left + cr.width * 0.08, sy = cr.top - r.top + cr.height * 0.3;
      var floorY = br.top - r.top + br.height * 0.15;
      gsap.timeline({ onComplete: done })
        .to(canImg, { rotation: -32, duration: 0.25, ease: WH.sm('power2.out', 0.25) })
        .add(function () {
          for (var k = 0; k < 8; k++) {
            (function (k) {
              var d = document.createElement('i'); d.className = 'wh-drop';
              d.style.left = (sx + WH.rand(-6, 6)) + 'px'; d.style.top = sy + 'px';
              stage.appendChild(d);
              gsap.to(d, { y: floorY - sy, x: WH.rand(-14, 10), duration: 0.42, delay: k * 0.07, ease: WH.sm('power2.in', 0.42), onComplete: function () { if (k % 3 === 0) WH.sound.play('drip'); d.remove(); } });
            })(k);
          }
        })
        .to(canImg, { rotation: -32, duration: 0.6 })
        .to(canImg, { rotation: 0, duration: 0.25, ease: WH.sm('power2.in', 0.25) })
        .to(bodies[i], { scaleY: 1.22, scaleX: 0.9, duration: 0.17, ease: WH.sm('power2.out', 0.17) }, '-=0.5')
        .to(bodies[i], { scaleY: 0.92, scaleX: 1.06, duration: 0.17, ease: WH.sm('power1.inOut', 0.17) }, '-=0.33')
        .to(bodies[i], { scaleY: 1, scaleX: 1, duration: 0.34, ease: WH.sm('elastic.out(1.2,.4)', 0.34) }, '-=0.16');
    }
    bodies.forEach(function (b, i) { b.addEventListener('click', function (e) { e.stopPropagation(); pour(i); }); });
    stage.addEventListener('click', function (e) {
      if (e.target.closest('a,button')) return;
      pour(nearest(stageX(e.clientX)));
    });
  });
})();
